<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Gestión Clínica</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Historia Clínica</span>
    </div>
  </div>
  <div class="d-flex my-xl-auto right-content mr-2">
    <button type="button" class="btn btn-primary btn-block" (click)="load()">
      <i class="fa fa-refresh me-1"></i>
      Actualizar
    </button>
  </div>
</div>

<div class="row row-sm">
  <div class="col-xl-12">
    <div class="card overflow-visible">
      <div class="card-body">
        <div class="table-controls">
          <div class="show-records">
            Mostrar
            <select class="form-control form-control-sm" [value]="limit" (change)="cambiarLimite($any($event.target).value)">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
            registros
          </div>
          <div class="search-box">
            <label>Buscar:</label>
            <input
              type="text"
              class="form-control form-control-sm"
              [ngModel]="searchTerm"
              (ngModelChange)="buscarMientrasEscribe($event)"
              placeholder="Paciente, documento, orden, factura, médico..."
              >
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="limpiar()">Limpiar</button>
          </div>
        </div>

        <div *ngIf="loading" class="text-center loading-state">
          <div class="spinner-grow" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <p class="text-center mt-2">Procesando por favor espere...</p>
        </div>

        <div class="alert alert-danger" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>

        <div class="table-responsive" *ngIf="!loading && !errorMessage">
          <table class="table table-bordered table-striped table-hover dt-ext orders-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Fecha</th>
                <th>Factura</th>
                <th>Nº Orden</th>
                <th>Paciente</th>
                <th>Documento</th>
                <th>Doctor</th>
                <th>Sucursal</th>
                <th>Responsable</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of rows; let rowIndex = index">
                <td>{{ offset + rowIndex + 1 }}</td>
                <td>{{ (row.fecha || row.FEC_ORD) | date:'yyyy-MM-dd HH:mm:ss' }}</td>
                <td>{{ row.invoice_number || '-' }}</td>
                <td>{{ row.order_number }}</td>
                <td>{{ row.patient_name }}</td>
                <td>{{ row.patient_document }}</td>
                <td>{{ row.doctor_name }}</td>
                <td>{{ row.branch_name || '-' }}</td>
                <td>{{ row.responsable || '-' }}</td>
                <td>
                  <div ngbDropdown class="d-inline-block" container="body" placement="bottom-right">
                    <button type="button" class="btn btn-primary btn-sm action-button" ngbDropdownToggle>
                      <i class="fa fa-cog"></i>
                    </button>
                    <div ngbDropdownMenu>
                      <button ngbDropdownItem type="button" (click)="verOrden(row)">
                        <i class="fa fa-eye me-1"></i> Ver Orden
                      </button>
                      <button ngbDropdownItem type="button" (click)="crearHistoria(row)">
                        <i class="fa fa-plus-square me-1"></i> Crear Historia Clínica
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="rows.length === 0">
                <td colspan="10" class="empty-state">
                  No existen datos
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table-footer">
          <div>Mostrando desde {{ desde }} al {{ hasta }} de {{ total }} elementos</div>
          <div class="pagination-actions">
            <button class="btn btn-sm btn-outline-primary" type="button" [disabled]="offset === 0" (click)="primeraPagina()">Primero</button>
            <button class="btn btn-sm btn-outline-primary" type="button" [disabled]="offset === 0" (click)="paginaAnterior()">Ant</button>
            <button class="btn btn-sm btn-primary" type="button">{{ paginaActual }}</button>
            <button class="btn btn-sm btn-outline-primary" type="button" [disabled]="offset + limit >= total" (click)="paginaSiguiente()">Sig</button>
            <button class="btn btn-sm btn-outline-primary" type="button" [disabled]="offset + limit >= total" (click)="ultimaPagina()">Último</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
